import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { Button } from '@shared/components';

interface Props {
  onCancel: () => void;
  onConfirm: () => void;
}

const { Text } = Typography;

const RemoveCareRecipientModal = ({ onCancel, onConfirm }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="text-center">
      <Text className="mb-2 block text-center text-base font-bold">
        {t('familyFriend.addFamilyFriends.remove.title')}
      </Text>
      <Text className="text-sm text-functional-black">{t('familyFriend.addFamilyFriends.remove.description')}</Text>

      <div className="mt-4 flex flex-col gap-4 md:flex-row-reverse">
        <Button className="w-full" key="confirm" onClick={onConfirm}>
          {t('button.confirm')}
        </Button>
        <Button className="w-full" key="cancel" onClick={onCancel} variant="secondary">
          {t('button.cancel')}
        </Button>
      </div>
    </div>
  );
};

export default RemoveCareRecipientModal;
